<div>
    <h2 class="name">{{ title }}</h2>
    <span class="bar" [style.backgroundColor]="colour"></span>
    <p class="price">£{{ price }} <span class="vat">+VAT</span></p>
    <p class="per-what">{{ perWhat }}</p>
    <p class="bold-line" *ngFor="let boldLine of boldLines;">{{ boldLine }}</p>
    <p class="line" *ngFor="let line of lines;">{{ line }}</p>
</div>